import {
  ESTRATEGIA_RETRY_PADRAO,
  FalhaHttp,
  type ClienteHttp,
  type RespostaHttp,
} from '@next/infraestrutura/http'

import type { OpcaoEmpregador } from '../catalogo-empregador.tipos'

const ENDPOINT = '/employer'
const CAMPOS = [
  'id',
  'name',
  'code',
  'visivel',
  'id_repp',
  'jurisdicao',
  'trading_name',
  'cpf',
  'cnpj',
  'numero_identificador',
  'numero_identificador_tipo',
  'cno_caepf',
  'total_of_employees',
  'comp_man',
] as const

const ehRegistro = (valor: unknown): valor is Record<string, unknown> => (
  typeof valor === 'object' && valor !== null && !Array.isArray(valor)
)

const CAMPOS_PROJECAO = ['id', 'name', 'code', 'visivel', 'id_repp', 'jurisdicao', 'tradingName', 'cpf', 'cnpj', 'numeroIdentificador', 'numeroIdentificadorTipo', 'ceiCnoCaepf', 'totalOfEmployees', 'comp_man'] as const

const projetarCampos = (valor: Record<string, unknown>): OpcaoEmpregador => Object.fromEntries(
  CAMPOS_PROJECAO.filter(campo => campo in valor).map(campo => [campo, valor[campo]]),
) as OpcaoEmpregador

const criarFalhaRespostaInvalida = (
  resposta: RespostaHttp<unknown>,
): FalhaHttp => new FalhaHttp({
  tipo: 'resposta_invalida',
  servico: 'condominio',
  metodo: 'GET',
  endpoint: ENDPOINT,
  status: resposta.status,
  causa: resposta.data,
  ...(resposta.requestId ? { requestId: resposta.requestId } : {}),
})

export class ListarOpcoesEmpregadorRepositorioHttp {
  constructor(private readonly http: ClienteHttp) {}

  executar = async (
    sinal: AbortSignal,
  ): Promise<readonly OpcaoEmpregador[]> => {
    const resposta = await this.http.get<unknown>(ENDPOINT, {
      parametros: {
        fields: JSON.stringify(CAMPOS),
        order_by: 'name',
      },
      signal: sinal,
      retry: ESTRATEGIA_RETRY_PADRAO,
    })

    if (ehRegistro(resposta.data) && 'no-data' in resposta.data) return []
    if (!ehRegistro(resposta.data) || !Array.isArray(resposta.data.success)) {
      throw criarFalhaRespostaInvalida(resposta)
    }

    if (resposta.data.success.some(item => !ehRegistro(item))) {
      throw criarFalhaRespostaInvalida(resposta)
    }
    return resposta.data.success.map(item => projetarCampos(item as Record<string, unknown>))
  }
}
